<template>
	<span><code>{{basePath}}<strong>{{subPath}}</strong></code></span>
</template>

<script>
export default {
  props:{
    os: { type: String, default: "windows" },
	  path: { type: String, default: ''},
  },
  data() {
    return {
      winSep: "\\",
      linSep: "/",
      winPath: "C:\\Programme\\apache-tomcat\\",
      linPath: "/var/lib/tomcat/"
    }
  },
  computed: {
    basePath: function() {
      return (this.os == "windows") ? this.winPath : this.linPath;
    },
    subPath: function() {
      return (this.os == "windows") ? this.path.replace(/\//g, this.winSep) : this.path;
    }
  }
}

</script>
